// extracted by mini-css-extract-plugin
export default {"addLabel":"EmailsEdit_addLabel__MRdjz"};